import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationWithCommentDialogData } from '../../../models/confirmation-with-comment-dialog-data';

@Component({
  selector: 'app-confirmation-with-comment-dialog',
  templateUrl: './confirmation-with-comment-dialog.component.html',
  styleUrls: ['./confirmation-with-comment-dialog.component.scss'],
  standalone: false
})
export class ConfirmationWithCommentDialogComponent implements OnInit {

  dialogData: ConfirmationWithCommentDialogData;

  public comment: string;
  public confirmationForm: UntypedFormGroup;
  get commentCtrl() { return this.confirmationForm.controls.comment; }

  constructor(
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<ConfirmationWithCommentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: ConfirmationWithCommentDialogData
  ) {
    if (data) {
      this.dialogData = { ...data };
    }
  }

  ngOnInit() {
    this.createForm();
  }

  public createForm() {
    this.confirmationForm = this.fb.group({
      comment: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(this.dialogData?.minLength ? this.dialogData?.minLength : 25),
        Validators.maxLength(this.dialogData?.maxLength ? this.dialogData?.maxLength : 1000)
      ])
    });
  }

  public hasErrorOfType(controlName: string, errorType: string): boolean {
    const ctrl = this.confirmationForm.controls[controlName];
    return ctrl && (ctrl.touched || ctrl.dirty) && ctrl.hasError(errorType);
  }

  closeDialog() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.dialogData.isConfirmed = true;
  }
}
